import {START_TRIGGER_TRACK} from 'constants/action-types.js';
import {STOP_TRIGGER_TRACK} from 'constants/action-types.js';
import {SET_SAMPLE_TOOLTIP} from 'constants/action-types.js';
import {SET_ALL_TRACK_STEPS} from 'constants/action-types.js';
import {SET_TRACK_STEPS} from 'constants/action-types.js';
import {SET_TRACK_FILLS} from 'constants/action-types.js';
import {SET_TRACK_PIANO_ROLL_STEPS} from 'constants/action-types.js';
import {SET_TRACK_MUTED} from 'constants/action-types.js';
import {SET_TRACK_SOLO} from 'constants/action-types.js';
import {SET_TRACK_VOLUME} from 'constants/action-types.js';
import {SET_GROUP_MUTED} from 'constants/action-types.js';
import {SET_GROUP_VOLUME} from 'constants/action-types.js';
import {SET_SAMPLE_AUDITIONING} from 'constants/action-types.js';
import {SET_RIGHT_SIDEBAR_OPTION} from 'constants/action-types.js';

let initialState = {
    sampleAuditioning: undefined,
    rightSidebarOption: "Tools"
};
    
const auditionReducer= (state = initialState, action) => {
    let newState;
    switch (action.type) {
    case SET_RIGHT_SIDEBAR_OPTION: 
        return {
            ... state,
            rightSidebarOption: action.payload
        };
    case SET_SAMPLE_AUDITIONING:
        return {... state,
                sampleAuditioning: action.payload
               };
    case SET_SAMPLE_TOOLTIP:
        return {... state,
                sampleTooltip: action.payload
               };
    default:
        return state;
    }
};

export default auditionReducer;
